import cx from 'classnames';
import { naturalShortDate, relativeDateShort } from '../../../../../../../shared/frontend/libs/utils';
import { GuildCard } from '../../presentational/raidRankingsElements/GuildCard';
import { SimpleTooltip } from '../../../../../../../shared/frontend/components/presentational/tooltip';
import _ from 'lodash';
import { asset } from '../../../../../../../shared/frontend/services/assetResolverService';
import { Link } from '../../../../../../../shared/frontend/components/link';
import { namedRoutes, resolveRoutePath } from '../../../bundles/routes';
import { t } from 'i18next';

export function RecentGuildRankingsTableFrontpage(props: any) {
  return (
    <table
      className={cx(
        'slds-table',
        'slds-table--bordered',
        'slds-table--striped',
        'slds-table--no-cell-buffer',
        'rio-rankings-table'
      )}
    >
      <thead>
        <tr>
          <th colSpan={3} className="slds-text-align--center text-white slds-text-heading--small">
            {props.title}
          </th>
        </tr>
      </thead>
      <tbody>
        {props.guilds.length === 0 && (
          <tr>
            <td
              colSpan={3}
              className="rio-background--header"
              style={{
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${asset(
                  `/images/${props.raid.slug}/headers/_zone.jpg`
                )})`
              }}
            >
              <div
                className="slds-p-around--large slds-text-align--center slds-align--absolute-center slds-text-heading--medium"
                style={{ minHeight: '250px', whiteSpace: 'normal' }}
              >
                {t('common:errors.empty-guild-leaderboard')}
              </div>
            </td>
          </tr>
        )}
        {props.guilds.map((guild: any, index: number) => (
          <tr key={index} className={`faction--${guild.guild.faction}`}>
            <td
              className="slds-text-align--right text-muted"
              style={{ width: 1 }}
              title={naturalShortDate(guild.recentEncounter.defeatedAt)}
            >
              {relativeDateShort(guild.recentEncounter.defeatedAt)}
            </td>
            <td data-label="Guild" className="slds-cell-wrap">
              <GuildCard
                guild={guild.guild}
                raid={props.raid}
                difficulty={guild.recentEncounter.difficulty}
                streamers={guild.streamers}
                recruitmentProfiles={guild.recruitmentProfiles}
              />
            </td>
            <td className="slds-text-align--right text-muted">
              <SimpleTooltip
                placement="top"
                tooltip={
                  <div>
                    <b>{t(`raids:${props.raid.slug}.bosses.${guild.recentEncounter.slug}.name`)}</b>
                    <br />
                    {naturalShortDate(guild.recentEncounter.defeatedAt)}
                  </div>
                }
              >
                {_.capitalize(guild.recentEncounter.difficulty)}{' '}
                <span
                  className="slds-avatar slds-avatar--small slds-m-left--x-small rio-border--light"
                  title={props.raid.name}
                >
                  <img src={asset(guild.recentEncounter.iconUrl)} alt={guild.recentEncounter.name} />
                </span>
              </SimpleTooltip>
              {/* <ProgressBadge
                title="Raid Progress"
                numDefeated={guild.encountersDefeated.length}
                totalBosses={props.raid.encounters.length}
                difficulty={props.difficulty}
                visible={props.raid.encounters.length > 0}
              /> */}
            </td>
          </tr>
        ))}
      </tbody>
      <tfoot>
        <tr>
          <td colSpan={3} className="slds-text-align--center slds-text-body--small">
            {props.recent ? (
              <span>&nbsp;</span>
            ) : (
              <Link
                className="rio-realm-link--muted"
                to={resolveRoutePath(namedRoutes.RaidRankings, {
                  raid: props.raid.slug,
                  difficulty: props.difficulty,
                  region: 'world'
                })}
              >
                {t('common:leaderboard.view-leaderboard-prompt')}
              </Link>
            )}
          </td>
        </tr>
      </tfoot>
    </table>
  );
}
